import { render, staticRenderFns } from "./ContactPersonPage.vue?vue&type=template&id=c5784d9c&scoped=true"
import script from "./ContactPersonPage.vue?vue&type=script&lang=js"
export * from "./ContactPersonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5784d9c",
  null
  
)

export default component.exports